import { Outlet } from 'react-router-dom';
import { PublicNavigation } from './PublicNavigation';

/** Landing, pricing, docs, legal and sign-in pages render here whether or not someone is signed in. */
export function PublicLayout() {
  return (
    <>
      <PublicNavigation />
      <Outlet />
    </>
  );
}
